import { render } from "./PaperSlogan.vue?vue&type=template&id=49a101ab&scoped=true"
import script from "./PaperSlogan.vue?vue&type=script&lang=js"
export * from "./PaperSlogan.vue?vue&type=script&lang=js"

import "./PaperSlogan.vue?vue&type=style&index=0&id=49a101ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a101ab"]])

export default __exports__